module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-5-27d65af93231c6e530d6223c112a7226.png";